import { ReactNode } from "react";

interface DomainRouterProps {
  children: ReactNode;
}

/**
 * DomainRouter - Simplified single-domain architecture
 * 
 * All routes now live under bortal.lovable.app (no subdomain split).
 * This component is kept for potential future domain logic but
 * currently just passes through children.
 */
const DomainRouter = ({ children }: DomainRouterProps) => {
  return <>{children}</>;
};

export default DomainRouter;
